import SearchIcon from '@mui/icons-material/Search';

export default SearchIcon;
